var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 353,
    height: 310,
    viewBox: "0 0 353 309.752",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M232.874 120.639C233.362 111.148 235.555 104.198 235.555 104.198C234.209 104.598 232.821 104.845 231.41 104.939L223.524 105.444C220.654 105.627 217.82 104.762 215.539 103.016C215.539 103.016 213.369 102.998 210.681 102.051C203.878 99.6582 201.679 93.9072 201.679 93.9072V93.8543C200.162 93.6073 198.874 92.543 198.386 91.0494C197.604 88.6325 196.763 84.4693 196.822 77.8186C196.833 76.3426 197.451 74.9372 198.533 73.9317L212.01 61.4066L211.246 59.8248C209.799 56.8199 209.394 53.427 210.093 50.1693L214.433 28.2709C215.503 22.8845 218.579 18.1038 223.048 14.8931L236.526 5.2141C239.795 2.86784 243.788 1.75058 247.804 2.05636L258.3 2.63263C261.676 2.60323 264.439 2.93252 265.38 3.40883L283.115 12.4763C286.885 14.4051 290.031 17.357 292.195 20.9969L295.352 26.348C296.975 27.7769 298.275 29.5469 299.151 31.5462L309.012 54.1561C309.853 56.0849 309.789 58.29 308.842 60.1717L305.631 66.5166L324.166 91.1199C327.765 95.8948 330.464 101.275 332.146 107.009L337.509 125.296C340.025 133.876 341.301 142.773 341.301 151.717L338.973 206.986L248.974 152.922C245.064 150.576 240.142 150.752 236.408 153.369L224.259 161.907L219.12 169.287L253.449 191.103C254.125 191.533 254.537 192.279 254.537 193.085L254.549 196.919C254.549 197.725 254.137 198.477 253.461 198.912L180.539 245.255C179.769 245.743 178.787 245.743 178.016 245.255L78.3386 181.965C77.827 181.642 77.5212 181.077 77.5212 180.478V174.926L77.533 174.909L76.6098 174.321C76.0159 173.944 75.5749 173.362 75.369 172.686L65.1373 138.686L53.847 101.158C53.4883 99.9698 54.0411 98.6938 55.1524 98.141L57.8515 96.8003C58.6806 96.3887 59.6685 96.4299 60.4624 96.9121L96.3618 118.84L131.697 140.421L151.049 128.095C152.037 127.466 153.307 127.466 154.295 128.095L184.214 147.107L190.412 138.686L215.527 122.139L232.862 120.639H232.874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M334.045 113.812C311.941 74.5375 301.15 75.4784 301.15 75.4784L305.59 66.4756C305.59 66.4756 325.883 92.008 329.358 99.4055C332.987 107.138 334.045 113.812 334.045 113.812Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M315.374 149.587C315.374 149.587 296.616 167.61 278.445 170.327L333.391 203.251C333.391 203.251 301.12 187.439 315.38 149.593L315.374 149.587Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M126.858 173.886C127.717 182.413 121.713 186.159 113.445 182.242C105.178 178.326 97.7801 168.241 96.9216 159.715C96.063 151.188 102.067 147.443 110.335 151.359C118.602 155.275 126 165.36 126.858 173.886Z",
    fill: "#FFFF05"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M117.191 166.242L117.667 164.054L114.574 162.59L114.098 164.777L117.191 166.242Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M111.838 163.708L113.319 164.407L113.79 162.22L111.496 161.132C110.467 160.644 109.973 160.538 109.45 160.562C108.639 160.603 107.945 161.05 107.704 162.143L107.521 162.978L106.386 162.443L105.91 164.631L107.045 165.166L106.098 169.541L109.191 171.005L110.138 166.63L112.102 167.559L112.578 165.372L110.614 164.443L110.714 163.99C110.785 163.649 110.979 163.49 111.291 163.519C111.42 163.531 111.661 163.625 111.832 163.702L111.838 163.708Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M114.029 165.401L112.482 172.558L115.575 174.022L117.122 166.866L114.029 165.401Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M272.825 59.6882C269.52 53.7138 263.934 46.5103 263.934 46.5103L264.874 37.5781C264.874 37.5781 270.69 40.4713 272.831 59.6941",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M283.963 130.925C283.963 130.925 291.813 125.015 291.525 116.747",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M274.578 112.278C264.275 100.206 235.238 104.722 235.238 104.722C235.238 104.722 251.145 96.3307 256.948 90.9443L274.578 112.278Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M182.321 235.187L177.687 238.257L177.964 238.439C178.811 238.992 179.893 238.998 180.745 238.457L253.826 192.19C254.167 191.973 254.167 191.479 253.826 191.267L154.29 128.006C153.26 127.354 152.067 127.348 151.044 128.006L131.691 140.332L155.419 154.815C156.512 155.485 156.889 156.109 157.294 157.326L182.897 233.506C183.109 234.129 182.874 234.817 182.321 235.181V235.187Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M75.3795 183.906C75.5854 184.583 76.0205 185.165 76.6203 185.541L77.5435 186.129L77.5318 186.147V191.698C77.5318 192.303 77.8434 192.862 78.3491 193.186L178.027 256.476C178.797 256.964 179.779 256.964 180.549 256.476L259.193 202.988C259.875 202.553 260.287 201.806 260.281 200.995L260.269 197.161C260.269 196.361 259.857 195.614 259.181 195.179L225.516 173.786C225.746 173.522 225.946 173.263 226.104 173.01L228.11 169.882C230.05 166.853 226.828 171.369 229.756 169.282L242.487 160.191L342.129 220.117L200.437 310.163L6.70898 187.041L65.1478 149.9L75.3795 183.9V183.906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M75.3795 172.674C75.5854 173.35 76.0205 173.932 76.6203 174.309L77.5435 174.897L77.5318 174.914V180.465C77.5318 181.071 77.8434 181.63 78.3491 181.953L178.027 245.243C178.797 245.731 179.779 245.731 180.549 245.243L253.471 198.9C254.154 198.465 254.565 197.718 254.559 196.907L254.548 193.073C254.548 192.273 254.136 191.526 253.46 191.091L219.795 169.698C220.024 169.434 220.224 169.175 220.383 168.922L222.388 165.794C224.328 162.766 226.833 160.137 229.756 158.05L242.487 148.959L342.129 208.885L200.437 298.931L6.70898 175.814L65.1478 138.674L75.3795 172.674Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M131.712 140.414L151.064 128.089C152.052 127.46 153.322 127.46 154.31 128.089L184.394 147.206L187.469 141.843C188.669 140.42 190.004 139.114 191.456 137.956C192.356 137.233 194.49 135.651 195.502 135.104L206.463 127.377L142.961 89.2256L96.377 118.833L131.712 140.414Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M206.469 127.377L142.961 89.2256L96.377 118.833",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M242.552 149.059L342.135 208.885L200.443 298.931L6.70898 175.814L65.1478 138.674L75.3796 172.674",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M77.5254 174.914L177.832 238.633C178.702 239.186 179.82 239.186 180.69 238.633L254.259 191.955",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M184.099 147.018L154.309 128.089C153.315 127.46 152.051 127.46 151.063 128.089L131.711 140.414",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M77.5254 174.915V180.466C77.5254 181.071 77.837 181.63 78.3428 181.953L178.02 245.243C178.791 245.732 179.773 245.732 180.543 245.243L253.465 198.901C254.147 198.465 254.559 197.719 254.553 196.907L254.541 193.073C254.541 192.273 254.13 191.527 253.453 191.091L219.124 169.275",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M180.545 155.427L166.603 165.77C166.039 166.111 166.039 166.929 166.603 167.276L196.657 186.528C197.575 187.11 198.751 187.098 199.651 186.487L217.768 174.432C218.327 174.062 218.315 173.232 217.744 172.88L216.968 172.392",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M218.48 205.927L161.506 169.786",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M181.529 229.406L218.481 205.926",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M176.505 237.785L76.6215 174.307C76.0276 173.931 75.5866 173.349 75.3808 172.672L53.8587 101.138C53.5 99.9503 54.0528 98.6743 55.1642 98.1215L57.8632 96.7808C58.6924 96.3692 59.6803 96.4103 60.4741 96.8925L155.265 154.79C156.241 155.384 156.965 156.313 157.311 157.401L182.962 233.663C183.132 234.192 182.979 234.769 182.579 235.151L178.986 237.538C178.31 238.179 177.293 238.273 176.511 237.779L176.505 237.785Z",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M53.9707 99.54L151.261 159.684C152.219 160.278 152.937 161.195 153.284 162.266L178.987 237.552",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M215.561 42.9121C215.561 42.9121 218.519 43.4649 220.366 46.7402C222.212 50.0097 220.366 53.6261 220.366 53.6261L198.526 73.9191C197.444 74.9247 196.827 76.3359 196.815 77.8178C196.762 84.4684 197.597 88.62 198.379 91.0427C198.932 92.7538 200.549 93.9005 202.348 93.9005C203.783 93.9005 205.183 93.4301 206.323 92.5657L207.247 91.8659L207.458 92.8068C208.17 95.9469 209.963 98.7341 212.515 100.692L215.532 103.003C217.814 104.756 220.648 105.614 223.517 105.432L231.403 104.926C234.702 104.714 237.883 103.638 240.629 101.81L256.941 90.9368",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M214.596 58.9844L215.295 43.966C215.472 40.1614 216.46 36.4392 218.189 33.0403L222.628 24.3257C224.522 20.6034 227.262 17.381 230.631 14.9054L242.086 6.48475C247.767 1.93925 262.909 2.12741 265.39 3.39169L283.125 12.4592C286.894 14.3879 290.04 17.3398 292.204 20.9798L295.139 25.9193",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M281.524 18.75L293.191 24.7538C295.837 26.3356 297.924 28.7113 299.159 31.5397L309.021 54.1496C309.862 56.0784 309.797 58.2835 308.85 60.1652L293.602 90.2843C292.174 93.2539 288.445 94.2712 285.705 92.4365L280.442 88.9142C279.207 88.085 278.343 86.8031 278.049 85.3389L270.222 46.4111C269.758 44.1119 268.711 41.9773 267.17 40.2073L264.871 37.5671",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M258.305 2.61994L247.809 2.04366C243.792 1.73788 239.8 2.85515 236.53 5.2014L223.052 14.8804C218.583 18.0911 215.502 22.8718 214.438 28.2582L210.098 50.1566C209.398 53.4143 209.804 56.8131 211.25 59.8121L212.015 61.3939",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M305.633 66.5107L324.168 91.1141C327.766 95.8889 330.465 101.269 332.147 107.003L337.51 125.291C340.027 133.87 341.303 142.767 341.303 151.711L338.974 206.98",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M315.374 149.587C315.374 149.587 297.421 168.022 278.445 170.327",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M201.676 93.8994C201.676 93.8994 203.875 99.6563 210.679 102.044C213.366 102.99 215.536 103.008 215.536 103.008",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M235.555 104.197C235.555 104.197 231.415 111.077 228.822 121.027",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M251.19 61.112C251.649 60.9355 251.772 60.3534 251.431 60.0006C249.802 58.3188 245.803 54.3613 244.275 54.3613C242.334 54.3613 240.111 54.6377 240.111 58.4305C240.111 62.2233 241.223 63.3347 243.44 63.3347C245.133 63.3347 249.302 61.8294 251.184 61.112H251.19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M217.978 53.9834C217.113 53.2366 216.09 51.8959 215.761 49.5144C215.561 48.0678 215.044 43.6635 215.561 42.9049C216.079 42.1463 218.295 44.4808 219.048 45.0865C220.342 46.1332 221.547 50.6846 221.065 51.8312C220.601 52.9426 220.013 55.7299 217.978 53.9776V53.9834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M207.252 91.8654C207.252 91.8654 215.114 88.7547 217.078 87.0024C223.023 81.7042 210.775 75.618 206.3 75.4475C204.659 75.3828 201.46 75.7415 201.995 81.0691C202.483 85.891 207.246 91.8654 207.246 91.8654H207.252Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M241.292 123.556L242.492 148.965L224.21 161.813L216.912 172.298L212.12 174.174C209.268 175.291 206.128 175.45 203.182 174.626L199.747 173.668L195.643 174.138C192.768 174.468 189.892 173.503 187.799 171.51L185.917 169.716L182.659 166.617C181.424 165.441 180.73 163.812 180.73 162.113V155.092C180.73 152.881 181.436 150.723 182.747 148.941L188.016 141.779C189.569 139.674 191.48 137.857 193.667 136.416L207.192 127.507C212.625 123.926 218.876 121.768 225.362 121.239C230.778 120.792 236.223 121.592 241.286 123.567L241.292 123.556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M204.823 153.851L202.188 157.626C200.336 160.284 199.401 163.471 199.525 166.711L199.795 173.762L203.229 174.72C206.181 175.544 209.315 175.385 212.167 174.268L216.96 172.392L224.257 161.907L242.539 149.059",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M193.633 148.064L188.276 154.627C186.788 156.456 185.971 158.737 185.971 161.095V169.804",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M199.802 173.76L195.698 174.231C192.822 174.56 189.947 173.596 187.853 171.602L182.714 166.71C181.479 165.534 180.785 163.905 180.785 162.205V155.184C180.785 152.973 181.491 150.815 182.802 149.034L188.071 141.871C189.623 139.766 191.534 137.949 193.722 136.508L207.247 127.6C212.68 124.019 218.931 121.86 225.417 121.331C230.833 120.884 236.278 121.684 241.341 123.66L261.028 131.351C273.6 136.261 285.949 135.326 296.692 116.345",
    stroke: "black",
    strokeWidth: 0.503077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 353,
    height: 309.752,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty_cart.30e6dced45dcb24e3613095fd9d4751d.svg";
export { ForwardRef as ReactComponent };